var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 93.407,
    height: 70.632,
    viewBox: "0 0 93.407 70.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_2",
    x: 0,
    y: 0.953,
    width: 53.197,
    height: 53.219,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.31
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_2-2",
    x: 0,
    y: 0.953,
    width: 53.197,
    height: 53.219,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.31,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_11",
    x: 4.307,
    y: 21.852,
    width: 34.679,
    height: 34.219,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.31
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_17",
    x: 44.847,
    y: 0,
    width: 47.195,
    height: 45.099,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.31
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_18",
    x: 44.847,
    y: 24.347,
    width: 48.56,
    height: 46.285,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.31
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_10",
    x: 3.677,
    y: 1.596,
    width: 27.328,
    height: 67.798,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.31
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_16",
    x: 44.847,
    y: 1.596,
    width: 27.328,
    height: 67.798,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.31
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-542 -271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Words",
    transform: "translate(551 277)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 9.328,
    height: 25.142,
    transform: "translate(12.184 34.357) rotate(-43)",
    fill: "#0d3c68"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Subtraction_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2-3",
    "data-name": "Subtraction 2",
    d: "M17.588,35.219a17.743,17.743,0,0,1-3.549-.358,17.511,17.511,0,0,1-6.3-2.65,17.59,17.59,0,0,1-7.284-10.5H2.069V19.62H.092c-.03-.267-.055-.538-.073-.8h2.05V16.725H0c.013-.269.033-.539.058-.8H2.069V13.831H.385a17.511,17.511,0,0,1,2.6-6.067,17.662,17.662,0,0,1,7.748-6.38A17.519,17.519,0,0,1,14.039.358a17.78,17.78,0,0,1,7.1,0,17.511,17.511,0,0,1,6.3,2.65,17.66,17.66,0,0,1,6.38,7.748,17.509,17.509,0,0,1,1.026,3.306,17.78,17.78,0,0,1,0,7.1,17.512,17.512,0,0,1-2.65,6.3,17.662,17.662,0,0,1-7.748,6.38,17.519,17.519,0,0,1-3.306,1.026A17.741,17.741,0,0,1,17.588,35.219ZM17.105,6.111A11.016,11.016,0,1,0,28.121,17.127,11.029,11.029,0,0,0,17.105,6.111Z",
    transform: "translate(9 6.95)",
    fill: "#f95939"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Subtraction_2-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2-4",
    "data-name": "Subtraction 2",
    d: "M17.588,35.219a17.743,17.743,0,0,1-3.549-.358,17.511,17.511,0,0,1-6.3-2.65,17.59,17.59,0,0,1-7.284-10.5H2.069V19.62H.092c-.03-.267-.055-.538-.073-.8h2.05V16.725H0c.013-.269.033-.539.058-.8H2.069V13.831H.385a17.511,17.511,0,0,1,2.6-6.067,17.662,17.662,0,0,1,7.748-6.38A17.519,17.519,0,0,1,14.039.358a17.78,17.78,0,0,1,7.1,0,17.511,17.511,0,0,1,6.3,2.65,17.66,17.66,0,0,1,6.38,7.748,17.509,17.509,0,0,1,1.026,3.306,17.78,17.78,0,0,1,0,7.1,17.512,17.512,0,0,1-2.65,6.3,17.662,17.662,0,0,1-7.748,6.38,17.519,17.519,0,0,1-3.306,1.026A17.741,17.741,0,0,1,17.588,35.219ZM17.105,6.111A11.016,11.016,0,1,0,28.121,17.127,11.029,11.029,0,0,0,17.105,6.111Z",
    transform: "translate(9 6.95)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-2",
    "data-name": "Rectangle 11",
    width: 9.328,
    height: 13.991,
    transform: "translate(23.87 27.85) rotate(49)",
    fill: "#1769b5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-2",
    "data-name": "Rectangle 17",
    width: 9.328,
    height: 30.576,
    transform: "translate(76.92 6) rotate(49)",
    fill: "#1769b5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-2",
    "data-name": "Rectangle 18",
    width: 9.328,
    height: 32.384,
    transform: "translate(53.85 37.39) rotate(-49)",
    fill: "#ee9649"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10-2",
    "data-name": "Rectangle 10",
    width: 9.328,
    height: 49.798,
    transform: "translate(12.68 7.6)",
    fill: "#1769b5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-2",
    "data-name": "Rectangle 16",
    width: 9.328,
    height: 49.798,
    transform: "translate(53.85 7.6)",
    fill: "#1769b5"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "TOYS",
    transform: "translate(579 339)",
    fill: "#ed2e07",
    fontSize: 8,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TOYS")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.6a9b26dbbd8768956c302c7d34303b27.svg";
export { ForwardRef as ReactComponent };